// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/frontend.scss
// module id = 116
// module chunks = 1